module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "teal white--text"
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('profile.certs.title')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-list', _vm._l((_vm.value.userCertificates), function(item) {
    return _c('v-list-tile', {
      key: item._self
    }, [_c('v-list-tile-content', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "mr-3"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.edit(item)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.remove(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.value.userCertificates.length === 0) ? _c('div', {
    staticClass: "text-xs-center my-5"
  }, [_vm._v(_vm._s(_vm.$t('profile.certs.noCerts')))]) : _vm._e(), _vm._v(" "), _c('certificate-form', {
    ref: "certForm",
    on: {
      "saved": _vm.saved
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d98f9376","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/Certificates.vue
// module id = 1101
// module chunks = 1